import { either, function as function_ } from "fp-ts";
import z from "zod";

import { OrderEntity } from "~/entities/order/@x/review";
import { EMPTY } from "~/shared/str";
import { zEmptyString } from "~/shared/zod";

const zOrderNumber = OrderEntity.zSchema.shape.number.nullable();
type OrderNumber = z.infer<typeof zOrderNumber>;

const zOrderNumberAsString = z.union([
  z
    .string()
    .nonempty()
    .superRefine((value, ctx) => {
      function_.pipe(
        Number(value),
        (value) => zOrderNumber.unwrap().safeParse(isNaN(value) ? EMPTY : value),
        ({ success, data, error }) => (success ? either.right(data) : either.left(error)),
        either.mapLeft(({ issues }) => {
          for (const { message, ...issue } of issues) {
            ctx.addIssue(issue);
          }
        }),
      );
    }),
  zEmptyString,
]);
type OrderNumberAsString = z.infer<typeof zOrderNumberAsString>;

function convertFromOrderNumberAsString(value: OrderNumberAsString): OrderNumber {
  return value.length === 0 ? null : zOrderNumber.parse(Number(value));
}

export { convertFromOrderNumberAsString, zOrderNumber, zOrderNumberAsString };
export type { OrderNumber, OrderNumberAsString };
